import { render } from "./LegoCombinedReporting.vue?vue&type=template&id=a60a50e0&scoped=true"
import script from "./LegoCombinedReporting.vue?vue&type=script&lang=js"
export * from "./LegoCombinedReporting.vue?vue&type=script&lang=js"

import "./LegoCombinedReporting.vue?vue&type=style&index=0&id=a60a50e0&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60a50e0"]])

export default __exports__